export const wordCount = (str: string) => (isForFullWidth: boolean): number => {
  return (count => (isForFullWidth ? Math.floor(count / 2) : count))(
    Array.from(str).reduce(
      (acc, c) => (c.match(/[ -~]/) !== null ? 1 : 2) + acc,
      0
    )
  );
};

export const truncate = (str: string) => (maxLength: number) => (
  isForFullWidth: boolean
): string => {
  return Array.from(str).reduce(
    (acc, s) => {
      const nextAcc = {
        length: acc.length + wordCount(s)(isForFullWidth),
        str: `${acc.str}${s}`,
      };
      if (nextAcc.length > maxLength) return acc;
      return nextAcc;
    },
    { length: 0, str: '' }
  ).str;
};
